export default {"src":"/_next/static/media/success-icon.fb7e0b7d.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};